import styled from 'styled-components';

export interface OnboardingContentProps {
  video: string;
  description: React.ReactNode;
}

export const OnboardingContent: React.FC<OnboardingContentProps> = ({ video, description }) => {
  return (
    <S.Container>
      <S.Video key={video} autoPlay loop height="330">
        <source src={video} />
      </S.Video>
      <S.Description>{description}</S.Description>
    </S.Container>
  );
};

const S = {
  Container: styled.div`
    display: flex;
    flex-direction: column;
    width: 577px;
  `,
  Video: styled.video`
    border-radius: 10px;
    width: 100%;
    border: 1px solid ${(props) => props.theme.secondary.softBlue1};
  `,
  Description: styled.div`
    color: ${({ theme }) => theme.algoanBlue};
    font-size: 13px;
    font-weight: 400;
    padding: 16px 0px 24px 5px;
  `,
};
